module.exports = __webpack_public_path__ + "static/media/4.9509e389.png";